import { Conversation } from '@nextforce/api'
import { useMemo } from 'react'
import { useUser } from 'users/queries/detail'
import { getConversationUnread } from '../utils'
import { useConversations } from './list'

type ConversationSectionType = 'group' | 'direct' | 'announcements' | 'custom'

export type ConversationsSection = {
  type: ConversationSectionType
  data: Conversation[]
  unread: number
}

export function useConversationsSections() {
  const { data: user } = useUser()
  const { data: conversations } = useConversations()
  const sectionsCache = useMemo(() => {
    if (!conversations) {
      return []
    } else {
      const sections: ConversationsSection[] = [
        {
          type: 'group',
          data: [],
          unread: 0,
        },
        {
          type: 'direct',
          data: [],
          unread: 0,
        },
        {
          type: 'announcements',
          data: [],
          unread: 0,
        },
      ]

      conversations.forEach(conversation => {
        const unreadStatus = getConversationUnread(conversation, user)
        switch (conversation.type) {
          case 'storeAll':
          case 'coverRequests':
          case 'storeRepository':
          case 'repository':
          case 'custom':
          case 'companyManagers':
          case undefined:
            sections[0].data.push(conversation)
            if (unreadStatus) {
              sections[0].unread += 1
            }
            break
          case 'adhoc':
          case 'dm':
            if (!conversation.status?.recentMessage) {
              break
            }
            sections[1].data.push(conversation)
            if (unreadStatus) {
              sections[1].unread += 1
            }
            break
          case 'nextAnnouncements':
          case 'companyAnnouncements':
          case 'nextManagementAnnouncements':
          case 'companyRepository':
          case 'companyLeaderboard':
            sections[2].data.push(conversation)
            if (unreadStatus) {
              sections[2].unread += 1
            }
            break
        }
      })

      sections.forEach(section =>
        section.data.sort((a, b) => {
          const timeCompare =
            (b.status?.recentMessage?.createdAt ?? 0) -
            (a.status?.recentMessage?.createdAt ?? 0)
          if (timeCompare !== 0) {
            return timeCompare
          }
          return (a.name ?? '').localeCompare(b.name ?? '')
        })
      )

      return sections
    }
  }, [conversations, user])
  return sectionsCache
}
